import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'planone-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
})
export class FilterButtonComponent {
  @Input()
  markActiveFilters?: boolean | null;

  @Input()
  screen?: string | null;

  @Output()
  filterButtonClicked = new EventEmitter<boolean>();

  onClick() {
    this.filterButtonClicked.emit(true);
  }
}
